import DialogRow from '@Pages/RetroSynthesis/ExportRoute/components/DialogRow';
import PropTypes from 'prop-types';
import React from 'react';
import { RadioButtonGroup } from '@els/els-react--radio-button';
import HeaderInfoIcon from '@Pages/RetroSynthesis/ProjectRoutes/components/HeaderInfoIcon';
import HeaderInfoTooltip from '@Pages/RetroSynthesis/ProjectRoutes/components/HeaderInfoTooltip';
import InnerHTML from '@Components/InnerHTML';

import './ExportSelection.theme.scss';

export class ExportRTSelections {
  static ALL = 'all';

  static SELECTED_ONLY = 'selectedOnly';
}

const RT_SELECTION_OPTIONS = {
  [ExportRTSelections.ALL]: 'All available data',
  [ExportRTSelections.SELECTED_ONLY]: 'Selected examples only',
};

function ExportSelection({ selection, setSelection, disableSelectedOnly }) {
  return (
    <DialogRow label="Export:" className="export-selection">
      <div className="rx-flex-column-container export-selection__container">
        <RadioButtonGroup.Option
          className="export-selection__checkbox"
          labelClassName="export-selection__selection-label"
          onChange={(selected) => {
            if (selected) {
              setSelection(ExportRTSelections.ALL);
            }
          }}
          checked={selection === ExportRTSelections.ALL}
          label={RT_SELECTION_OPTIONS[ExportRTSelections.ALL]}
        />
        <div className="rx-flex-row-container">
          <RadioButtonGroup.Option
            className="export-selection__checkbox"
            onChange={(selected) => {
              if (selected) {
                setSelection(ExportRTSelections.SELECTED_ONLY);
              }
            }}
            checked={selection === ExportRTSelections.SELECTED_ONLY}
            label={RT_SELECTION_OPTIONS[ExportRTSelections.SELECTED_ONLY]}
            disabled={disableSelectedOnly}
          />
          <div className="export-selection__tooltip">
            <HeaderInfoIcon tooltipId="export-selection-tooltip" />
            <HeaderInfoTooltip id="export-selection-tooltip" rightAlign>
              <div className="rs-tooltip-big__content tooltip-content">
                <InnerHTML html="Select this option to export selected examples only." tag="span" />
              </div>
            </HeaderInfoTooltip>
          </div>
        </div>
      </div>
    </DialogRow>
  );
}

ExportSelection.propTypes = {
  setSelection: PropTypes.func,
  selection: PropTypes.string,
  disableSelectedOnly: PropTypes.bool,
};

export default ExportSelection;
